import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import LoginAgent from './section-components/loginagent';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';

const LoginV3 = () => {
    return <div>
        <Navbar />
        <LoginAgent />
        <Footer />
    </div>
}

export default LoginV3